export const CLEAR = "CLEAR";
export const ADD_MEMBER = "ADD_MEMBER";
export const REMOVE_MEMBER = "REMOVE_MEMBER";
export const CLEAR_MEMBERS = "CLEAR_MEMBERS";



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/SelectedMembersForConfirmationType.js